export default __webpack_public_path__ + "static/media/Scenografia (1).4760af25.jpg";